import Icon from  '@material-ui/icons/EventNote';
import List from './SpeList';
import Edit from './SpeEdit';
import Create from './SpeCreate';
//import Show from './SpeShow';


export default {
    list: List,
    edit: Edit,
    create: Create,
   // show: Show,
    icon: Icon,
};
